import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  viewBox: "70 55 1080 890",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("polygon", {
  fill: "currentColor",
  points: "357.1 918 358.2 613.4 1107.4 103.7 1109.1 405.2 357.1 918"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M347.4,105.7c-17.3,7.9-34,16.8-50,26.8l-15.3,10.1c-111.6,76.8-184.9,205.3-184.9,351s27.7,172.6,74.9,241.1l184.9-121.7V102.3l-9.7,3.4Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M6.94 8.98H3.78v10.19h3.16V8.98ZM5.36 7.59a1.84 1.84 0 1 0 0-3.68 1.84 1.84 0 0 0 0 3.68ZM20.22 13.56c0-3.06-1.63-4.48-3.8-4.48a3.27 3.27 0 0 0-2.96 1.63h-.04V8.98h-3.03v10.19h3.16v-5.04c0-1.33.25-2.61 1.9-2.61 1.62 0 1.64 1.52 1.64 2.69v4.96h3.15v-5.61Z" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "14",
  x: "3",
  y: "5",
  rx: "2"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "m3 7 9 6 9-6" }, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.type === 'vecura')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
      : (_ctx.type === 'linkedin')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
  ]))
}